<template>
    <div class="product-type" >
        <h2>产品中心</h2>
        <ul ref="typeNav">
            <li 
                v-for="(item,index) in type"
                :key="item.id"
                :class="{selected: index==actIndex}"
                @touchstart="productType(index,item.name)"
            >
                {{item.name}}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'ProductType',
    props:{
        type: Array
    },
    mounted () {
        document.addEventListener('scroll',this.typeFixed)
    },
    watch: {
        type(){
            // this.productType(0,this.type[0].name)
        }
    },
    data () {
        return {
            actIndex: 0,
        }
    },
    methods: {
        productType(index,name){
            this.actIndex = index
            this.$emit('changeType',name)
        },
        typeFixed () {
            var typeUl = this.$refs.typeNav
            if(document.body.scrollTop >= 430){
                typeUl.className = 'typefixed'
            }else
                typeUl.className = ''
        }
    },
    computed: {
    },
    destroyed () {
        document.removeEventListener('scroll',this.typeFixed)
    }
}
</script>

<style lang="stylus" scoped>
    @import '~styles/varible.styl'
    @import '~styles/mixins.styl'
    .product-type
        width: 100%
        background: #fff
        padding: 0.72rem 3% 0.7rem
        box-sizing: border-box
        h2
            font-weight: 800
            text-align: center
            color: #333
            font-size: 0.4rem
            margin-bottom: 0.48rem
            letter-spacing: 1px
        ul
            margin: 0
            font-size:0.24rem
            li
                display: inline-block
                padding: 0.8em 1.5em
                cursor: pointer
                margin-right: 1.5%
                color: $black
                background: #ccc
                border-radius: 2px
            li.selected
                background: $black
                color: #fff
        .typefixed
            position: fixed
            z-index: 20
            top: 0
            left: 0
            background: $black
            padding: 5% 2%
            width: 100%
            box-sizing: border-box
            li.selected
                background: $yellow
                color: $black
</style>



// WEBPACK FOOTER //
// src/components/mobile/ProductType.vue